import { failureActionHandler, requestActionHandler } from 'store/helpers';
import { YEAR_MONTH_DAY_SLASH } from 'utils';
import injectReducer from 'store/injectReducer';
import moment from 'moment';
import { ITEMS_PER_PAGE_SIZE } from 'modules/admin-panel/utils';
import { IClientShort } from 'modules/admin-panel/models';
import {
	IAllSurveysResultReducer,
	IEmployees,
	IResponseRoundList,
} from '../models';
import * as types from '../ActionTypes';

export const InitialAllSurveysResultReducer: IAllSurveysResultReducer = {
	error: null,
	isLoading: false,
	isClientListLoading: false,
	isSurveyRoundListLoading: false,
	searchQuery: {
		clientId: '',
		startDate: moment().subtract(2, 'year').format(YEAR_MONTH_DAY_SLASH),
		endDate: moment().format(YEAR_MONTH_DAY_SLASH),
		query: '',
	},
	surveyRoundList: [],
	employees: [],
	clientList: [],
	roundsPerPage: ITEMS_PER_PAGE_SIZE,
};

export default injectReducer(InitialAllSurveysResultReducer, {
	[types.GET_SURVEY_ROUND_LIST.REQUEST]: (state: IAllSurveysResultReducer) => ({
		...state,
		isSurveyRoundListLoading: true,
	}),
	[types.GET_EMPLOYEE_LIST.REQUEST]: requestActionHandler,
	[types.GET_SHORT_CLIENT_LIST.REQUEST]: (state: IAllSurveysResultReducer) => ({
		...state,
		isClientListLoading: true,
	}),
	[types.UPDATE_DASHBOARD_CLIENT_LIST.REQUEST]: (
		state: IAllSurveysResultReducer,
	) => ({
		...state,
		isClientListLoading: true,
	}),

	[types.GET_EMPLOYEE_LIST.FAILURE]: failureActionHandler,
	[types.GET_SURVEY_ROUND_LIST.FAILURE]: (
		state: IAllSurveysResultReducer,
		{ payload }: { payload: Error },
	) => ({
		...state,
		error: payload,
		isSurveyRoundListLoading: false,
	}),
	[types.GET_SHORT_CLIENT_LIST.FAILURE]: (
		state: IAllSurveysResultReducer,
		{ payload }: { payload: Error },
	) => ({
		...state,
		error: payload,
		isClientListLoading: false,
	}),
	[types.UPDATE_DASHBOARD_CLIENT_LIST.FAILURE]: (
		state: IAllSurveysResultReducer,
		{ payload }: { payload: Error },
	) => ({
		...state,
		error: payload,
		isClientListLoading: false,
	}),

	[types.GET_SURVEY_ROUND_LIST.SUCCESS]: (
		state: IAllSurveysResultReducer,
		{
			payload: { content, totalElements, size },
		}: { payload: IResponseRoundList },
	) => ({
		...state,
		surveyRoundList: content,
		totalRoundElements: totalElements,
		roundsPerPage: size,
		isSurveyRoundListLoading: false,
		error: false,
	}),

	[types.GET_EMPLOYEE_LIST.SUCCESS]: (
		state: IAllSurveysResultReducer,
		{ payload }: { payload: Array<IEmployees> },
	) => ({
		...state,
		employees: payload,
		isLoading: false,
		error: false,
	}),

	[types.RESET_EMPLOYEE_LIST]: (state: IAllSurveysResultReducer) => ({
		...state,
		employees: InitialAllSurveysResultReducer.employees,
	}),

	[types.GET_SHORT_CLIENT_LIST.SUCCESS]: (
		state: IAllSurveysResultReducer,
		{ payload }: { payload: Array<IClientShort> },
	) => ({
		...state,
		clientList: payload,
		isClientListLoading: false,
	}),
	[types.UPDATE_DASHBOARD_CLIENT_LIST.SUCCESS]: (
		state: IAllSurveysResultReducer,
		{ payload }: { payload: Array<IClientShort> },
	) => ({
		...state,
		clientList: payload,
		isClientListLoading: false,
	}),
});
